import { ApiCatch } from "@/utils/decorators";
import {
  AppealDTO,
  AppealFileDTO,
  EditAppealDto,
  SaveAttachDTO,
} from "~/appeal.type";
import { Api } from "../api.service";

export class AppealService {
  @ApiCatch
  static async getStatuses(TypeRid: number) {
    const response = await Api.get(`/appeals/statuses/${TypeRid}`);
    return response.data;
  }

  @ApiCatch
  static async getTypes() {
    const response = await Api.get("/appeals/types");
    return response.data;
  }

  @ApiCatch
  static async getNewAppeal() {
    const response = await Api.get("/appeals/create");
    return response.data;
  }

  @ApiCatch
  static async getAppealList(req: AppealDTO) {
    const response = await Api.get("/appeals/list", { params: req });
    return response.data;
  }

  @ApiCatch
  static async deleteFile(req: AppealFileDTO) {
    const response = await Api.get("/appeals/deletefile", { params: req });
    return response.data;
  }

  @ApiCatch
  static async getFiles(req: SaveAttachDTO) {
    const response = await Api.get("/appeals/files", { params: req });
    return response.data;
  }

  @ApiCatch
  static async getFile(req: AppealFileDTO) {
    const response = await Api.get("/appeals/file", { params: req });
    return response.data;
  }

  @ApiCatch
  static async editAppeal(req: EditAppealDto) {
    const response = await Api.post("/appeals/edit", req);
    return response.data;
  }

  @ApiCatch
  static async saveAttach(req: SaveAttachDTO) {
    const response = await Api.post(
      "/appeals/save?iRequestRid=" + req.iRequestRid.toString(),
      req.data,
    );
    return response.data;
  }

  @ApiCatch
  static async sendToRoesAppeal(req: EditAppealDto) {
    const response = await Api.post("/appeals/send-to-roes", req);
    return response.data;
  }

  @ApiCatch
  static async getRequestsNotice() {
    const response = await Api.get("/appeals/notices");
    return response.data;
  }
}
